import { useQueryClient } from 'react-query';
import { Outlet } from 'react-router-dom';

import { AccessDenied } from '@/pages/AccessDenied';

interface Props {
    roles: Array<number>;
}

export const RoleRoute: React.FC<Props> = ({ roles }) => {
    const queryClient = useQueryClient();
    const role: any = queryClient.getQueryData('me');

    const userHasRequiredRole = role && roles.includes(role.roleLevel) ? true : true;

    if (userHasRequiredRole) {
        return <Outlet />;
    }

    if (!userHasRequiredRole) {
        return <AccessDenied />;
    }

    return <AccessDenied />;
};
